import { render, staticRenderFns } from "./NoteActions.vue?vue&type=template&id=16d310ba&scoped=true&"
import script from "./NoteActions.vue?vue&type=script&lang=js&"
export * from "./NoteActions.vue?vue&type=script&lang=js&"
import style0 from "./NoteActions.vue?vue&type=style&index=0&id=16d310ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d310ba",
  null
  
)

export default component.exports